import { render, staticRenderFns } from "./IconChecklistEl.vue?vue&type=template&id=1be2023e&scoped=true&"
import script from "./IconChecklistEl.vue?vue&type=script&lang=ts&"
export * from "./IconChecklistEl.vue?vue&type=script&lang=ts&"
import style0 from "./IconChecklistEl.vue?vue&type=style&index=0&id=1be2023e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be2023e",
  null
  
)

export default component.exports